var map = {
	"./drh5_language_en.png": "b451",
	"./drh5_language_jp.png": "bec2",
	"./drh5_language_kr.png": "b038",
	"./drh5_language_sc.png": "d915",
	"./drh5_language_tc.png": "db16"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c79";